<!-- <div class="">{{  'Login.SubmitButton' | translate:{'name':'user'} }}</div> -->
<!-- <div class="">{{ 'from variable ' + (message | translate) }}</div>
<button (click)="changeLang(val)">Changer de langue</button> -->
<router-outlet></router-outlet>